module.exports = __webpack_public_path__ + "static/media/gallery-7.d24ce789.jpg";